import { create } from 'zustand';
import axios from 'axios';

axios.defaults.baseURL = 'https://user-chart-settings-0f34130e1ea9.herokuapp.com';

function requireValue(value, label) {
  if (value === undefined || value === null || String(value).trim() === '') {
    throw new Error(`${label} is required.`);
  }
  return value;
}

const useLayoutStore = create((set) => ({
  layouts: [],

  loadLayouts: async (memberId) => {
    const scopedMemberId = requireValue(memberId, 'Member ID');
    const response = await axios.get('/api/chart_layouts', {
      params: { memberId: scopedMemberId },
    });
    const layouts = Array.isArray(response.data) ? response.data : [];
    set({ layouts });
    return layouts;
  },

  saveLayout: async ({ memberId, name, content, symbol }) => {
    const scopedMemberId = requireValue(memberId, 'Member ID');
    const response = await axios.post('/api/chart_layouts', {
      memberId: scopedMemberId,
      name,
      content,
      symbol,
      timestamp: Date.now(),
    });
    return response.data;
  },

  loadLayout: async ({ layoutId, memberId }) => {
    const scopedMemberId = requireValue(memberId, 'Member ID');
    const scopedLayoutId = requireValue(layoutId, 'Layout ID');
    const response = await axios.get(`/api/chart_layouts/${scopedLayoutId}`, {
      params: { memberId: scopedMemberId },
    });
    return response.data;
  },

  deleteLayout: async ({ layoutId, memberId }) => {
    const scopedMemberId = requireValue(memberId, 'Member ID');
    const scopedLayoutId = requireValue(layoutId, 'Layout ID');
    const response = await axios.delete(`/api/chart_layouts/${scopedLayoutId}`, {
      params: { memberId: scopedMemberId },
    });
    return response.data;
  },
}));

export default useLayoutStore;
